import { RefObject, useEffect, useState } from 'react';

export function useElementSize<T extends Element>(ref: RefObject<T | null>) {
  const [size, setSize] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });
  const element = ref.current;

  useEffect(() => {
    if (!element) {
      return;
    }

    const updateSize = () => {
      const rect = element.getBoundingClientRect();
      setSize(prev => {
        const changed =
          prev.width !== rect.width ||
          prev.height !== rect.height ||
          prev.left !== rect.left ||
          prev.top !== rect.top;

        if (!changed) {
          return prev;
        }

        return {
          width: rect.width,
          height: rect.height,
          left: rect.left,
          top: rect.top,
        };
      });
    };

    updateSize();

    const resizeObserver = new ResizeObserver(updateSize);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [element]);

  return size;
}
